import React from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';

const NumeralFormatter = (props) => {
  const v = props.value;
  const showDecimal = props.decimalScale > 0 || v % 1 !== 0;
  const scale = showDecimal ? (props.decimalScale || 2) : 0;
  const { columnKey } = props;
  const cn = columnKey ? `cell-${columnKey} numeral` : 'header-numeral';
  return (
    <div
      className={cn}
      style={{ width: 'max-content' }}
    >
      {showDecimal && (
        <NumberFormat
          displayType="text"
          thousandSeparator="."
          decimalSeparator=","
          decimalScale={scale}
          fixedDecimalScale={showDecimal}
          value={v}
        />
      )}
      {!showDecimal && v}
    </div>
  );
};

NumeralFormatter.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]),
  decimalScale: PropTypes.number,
  columnKey: PropTypes.string
};

NumeralFormatter.defaultProps = {
  value: null,
  decimalScale: 2,
  columnKey: null
};

export default NumeralFormatter;
